$(document).ready(function() {
    // Check if the URL includes "coffeesubscription"
    if (window.location.href.includes('spillthechisme')) {
      const elementToMove = $('.store-locator-secondary.nopad.nomin.gradient.multiply');
      const targetElement = $('.spill-chisme--hero');
  
      if (elementToMove.length > 0 && targetElement.length > 0) {
        elementToMove.insertAfter(targetElement);
      }

      setTimeout(function() {
        if (elementToMove.length > 0 && targetElement.length > 0) {
          elementToMove.insertAfter(targetElement);
        }

      }, 2000);

      $('.scratch-power').remove();
      
      // insert line break in tile copy 
      const contentDiv = document.querySelector('.line-break');
      let originalText = contentDiv.textContent;

      // swap out 'and ' with 'and <br>'
      const newText = originalText.replace('and ', 'and <br>');
      contentDiv.innerHTML = newText;
 
    }
  });
